import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
let tokenGetter = null;
let practiceId = null;
export const setTokenGetter = (f) => { tokenGetter = f; };
export const setPracticeId = (id) => { practiceId = id; };

export const api = axios.create({ baseURL: API });
api.interceptors.request.use(async (c) => {
  if (tokenGetter) {
    const t = await tokenGetter();
    if (t) c.headers.Authorization = `Bearer ${t}`;
  }
  if (practiceId) c.headers["X-Practice-Id"] = practiceId;
  return c;
});
const onErr = (e) => {
  if (e.response?.status === 423) window.dispatchEvent(new Event("ace:locked"));
  if (e.response?.status === 403 && /organization is suspended/.test(e.response?.data?.detail || "")) window.dispatchEvent(new Event("ace:org-suspended"));
  if (e.response?.status === 503 && e.response?.data?.maintenance) window.dispatchEvent(new CustomEvent("ace:maintenance", { detail: e.response.data.detail }));
  return Promise.reject(e);
};
api.interceptors.response.use((r) => r, onErr);

export const pub = axios.create({ baseURL: API });
pub.interceptors.response.use((r) => r, onErr);

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (d.message) return d.message + (d.missing ? `: ${d.missing.join("; ")}` : "");
  return JSON.stringify(d);
};

export const blobUrl = async (path) => URL.createObjectURL((await api.get(path, { responseType: "blob" })).data);

export const openBlob = async (path, download) => {
  const url = await blobUrl(path);
  const a = document.createElement("a");
  a.href = url;
  if (download) a.download = download; else a.target = "_blank";
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 60000);
};

export const newKey = () => (crypto.randomUUID ? crypto.randomUUID() : String(Date.now() + Math.random()));
